import React from "react";
import { Star } from "lucide-react";

const reviews = [
    {
        name: "Budi S.",
        location: "Jakarta",
        rating: 5,
        text: "Platform PUSATCUAN benar-benar terpercaya. Transaksi cepat, CS ramah, dan link resmi selalu bisa diakses.",
    },
    {
        name: "Andi R.",
        location: "Surabaya",
        rating: 5,
        text: "Main pusatcuan slot di sini rasa berbeda. RTP transparan, gamenya lengkap, withdraw lancar di bawah 3 menit.",
    },
    {
        name: "Dewi P.",
        location: "Bandung",
        rating: 5,
        text: "Situs hiburan online terpercaya favorit saya. Bonus promo konsisten dan customer service siap 24 jam.",
    },
    {
        name: "Rian H.",
        location: "Medan",
        rating: 4,
        text: "Interface bersih, akses game online terbaru mudah dicari. Deposit via e-wallet lancar tanpa kendala.",
    },
];

export default function Testimonials() {
    const avg =
        reviews.reduce((s, r) => s + r.rating, 0) / reviews.length;

    // Review + AggregateRating schema
    const schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "PUSATCUAN",
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: avg.toFixed(1),
            reviewCount: "2847",
            bestRating: "5",
            worstRating: "1",
        },
        review: reviews.map((r) => ({
            "@type": "Review",
            author: { "@type": "Person", name: r.name },
            reviewRating: {
                "@type": "Rating",
                ratingValue: r.rating,
                bestRating: "5",
            },
            reviewBody: r.text,
        })),
    };

    return (
        <section
            data-testid="testimonials-section"
            className="relative py-24 md:py-32 border-t border-white/5"
        >
            <script
                type="application/ld+json"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
            />
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
                    <div>
                        <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                            Testimoni Member
                        </span>
                        <h2 className="mt-4 text-3xl md:text-5xl font-medium tracking-tighter text-white">
                            Dipercaya{" "}
                            <span className="text-gold-gradient">2.800+ member</span> aktif
                        </h2>
                    </div>
                    <div className="flex items-center gap-4">
                        <div className="flex gap-1">
                            {[1, 2, 3, 4, 5].map((i) => (
                                <Star
                                    key={i}
                                    size={20}
                                    className="fill-[#D4AF37] text-[#D4AF37]"
                                />
                            ))}
                        </div>
                        <div>
                            <div className="text-2xl font-semibold text-white">
                                {avg.toFixed(1)}
                                <span className="text-white/50 text-sm">/5</span>
                            </div>
                            <div className="text-xs text-white/50">
                                dari 2.847 ulasan terverifikasi
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {reviews.map((r, i) => (
                        <article
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="rounded-2xl border border-white/5 bg-[#0c0c0c] p-7 hover:border-[#D4AF37]/40 transition-colors"
                        >
                            <div className="flex gap-0.5">
                                {Array.from({ length: r.rating }).map((_, k) => (
                                    <Star
                                        key={k}
                                        size={14}
                                        className="fill-[#D4AF37] text-[#D4AF37]"
                                    />
                                ))}
                            </div>
                            <p className="mt-5 text-white/75 leading-relaxed text-sm">
                                &ldquo;{r.text}&rdquo;
                            </p>
                            <div className="mt-6 pt-5 border-t border-white/5">
                                <div className="text-sm font-medium text-white">
                                    {r.name}
                                </div>
                                <div className="text-xs text-white/40">
                                    {r.location}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
